import { render } from "./LogoutMenuButton.vue?vue&type=template&id=4cd5c9bd"
import script from "./LogoutMenuButton.vue?vue&type=script&lang=js"
export * from "./LogoutMenuButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__